import React, { Component } from "react";
import { Icon } from "@iconify/react";
import angularIcon from "@iconify/icons-logos/angular-icon";
import reactIcon from "@iconify/icons-logos/react";
import vueIcon from "@iconify/icons-logos/vue";

class About extends Component {
  render() {
    if (this.props.sharedBasicInfo) {
      var profilepic = "images/" + this.props.sharedBasicInfo.image;
      var social = this.props.sharedBasicInfo.social || [];
      var instagramLink = social.find((s) => s.name && s.name.toLowerCase() === "instagram");
      var linkedinLink = social.find((s) => s.name && s.name.toLowerCase() === "linkedin");
    }
    if (this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.about;
      var hello = this.props.resumeBasicInfo.description_header;
      var about = this.props.resumeBasicInfo.description;
      var about_extra = this.props.resumeBasicInfo.description_extra || "";
    }

    return (
      <section id="about">
        <div className="col-md-12">
          <h1 style={{ color: "black" }}>
            <span>{sectionName}</span>
          </h1>
          <div className="row center mx-auto mb-5">
            <div className="col-md-4 mb-5 center">
              <div className="polaroid">
                <span style={{ cursor: "auto" }}>
                  <img
                    height="250px"
                    src={profilepic}
                    alt="Avatar placeholder"
                  />
                  
                  <div className="about-socials mt-3">
                    {instagramLink && (
                      <a
                        href={instagramLink.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <i className={instagramLink.class}></i>
                      </a>
                    )}

                    {linkedinLink && (
                      <a
                        href={linkedinLink.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                      >
                        <i className={linkedinLink.class || 'fab fa-linkedin'}></i>
                      </a>
                    )}

                    <a href="mailto:juliaddelmatto@gmail.com" aria-label="Email Julia">
                      <i className="fas fa-envelope"></i>
                    </a>
                  </div>
                </span>
              </div>
            </div>

            <div className="col-md-8 center">
              <div className="col-md-10">
                <div className="card about-card">
                  <div className="card-header">
                    <span
                      className="iconify"
                      data-icon="emojione:red-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:yellow-circle"
                      data-inline="false"
                    ></span>{" "}
                    &nbsp;{" "}
                    <span
                      className="iconify"
                      data-icon="twemoji:green-circle"
                      data-inline="false"
                    ></span>
                  </div>
                  <div
                    className="card-body font-trebuchet text-justify ml-3 mr-3 about-card-body"
                    style={{
                      fontSize: "132%",
                      lineHeight: "200%",
                      //backgroundColor:"#2d2929",
                      color: "white",
                    }}
                  >
                    <span className="wave">{hello}</span>
                    <p>{about}</p>
                    {about_extra && <p>{about_extra}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
